import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import ReportButtons from 'components/common/ReportButtons'
import {connect} from 'react-redux'
import {getCode6Nested} from 'actions/reportActions';
import * as XLSX from 'xlsx';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import { saveAs } from 'file-saver';

const Report6 = (props) => {
  const { tableData, showOPK, showOPKtoggle, refresh, getCode6Nested, nestedLoading, title} = props
  const valueConvert = (val) => {
    return (Number(val).toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
  }

  const header = ['Nazwa grupy kosztów', 'Wartość kosztu [zł]', 'Udział w koszcie całkowitym OPK']
  const [showOPKnested, setShowOPKnested] = React.useState({})
  const [refreshNested, setRefreshNested] = React.useState(false)
  const showOPKnestedtoggle = (opk, active) => {
    let temp = showOPKnested
    if (showOPKnested[opk] !== undefined) { //if that opk was clicked before, toggle view on that row
      temp[opk] = !showOPKnested[opk]
      setShowOPKnested(temp)
      setRefreshNested(!refreshNested)
    } else { //first time for that opk -> get children from API
      let params = {}
      params.category = active
      params.subcategory = opk
      getCode6Nested(params)
      temp[opk] = true
      setShowOPKnested(temp)
    }
  }
  const downloadXlsx = () =>{
    var wb = XLSX.utils.table_to_book(document.getElementById('tabela6'), {sheet:"Sheet JS", raw:true});
        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        let filename = title+'.xlsx';
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
  }
  const s2ab = (s)=>{
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
  }
  const downloadCSV = () =>{
      let filename = title+'.csv';
      var tableSelect = document.getElementById('tabela6')
      var tableHTML = tableSelect.outerHTML;
      var csv = [];
      var rows = document.querySelectorAll(`#tabela6 tr`);
      
      for (var i = 0; i < rows.length; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");
          
          for (var j = 0; j < cols.length; j++) 
              // row.push(cols[j].innerText.replace(",","."));
              row.push(cols[j].innerText);
          
          csv.push(row.join(";"));		}
          csv = csv.join("\n")

      var csvFile;
      var downloadLink;
      // CSV FILE
      var universalBOM = "\uFEFF";
      csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
      // Download link
      downloadLink = document.createElement("a");
      // File name
      downloadLink.download = filename;
      // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
      // Make sure that the link is not displayed
      downloadLink.style.display = "none";
      // Add the link to your DOM
      document.body.appendChild(downloadLink);
      // Lanzamos
      downloadLink.click();
  }

  //DOC
  const getTableRow = (values, format={}) => {
    let row = []
    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold, 
              color: format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    //TABLE
    let rows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(header.length).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: [AlignmentType.LEFT].concat(Array(2).fill(AlignmentType.RIGHT))
    }
    //header
    rows.push(new TableRow({
      children: getTableRow(header, headerStyle),
      tableHeader: true
    }))
    //body
    Object.entries(tableData).map(([opk, item]) => {
      rows.push(new TableRow({
        children: getTableRow([
            opk,
            valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']),
            valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%',
        ], opk==='Wartość ogółem'?{...bodyStyle, bold: true}:bodyStyle)
    }))

      if(item['children'] !== undefined && showOPK[opk]){
        Object.entries(item['children']).map(([opk2, item2]) => {
          rows.push(new TableRow({
            children: getTableRow([
                opk2,
                valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]']),
                valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%',
            ], {...bodyStyle, backgroundColor:'white' })
          }))
          if(item2['children'] !== undefined && showOPKnested[opk2]){
            alert('child')
            Object.entries(item2['children']).map(([opk3, item3]) => {
              rows.push(new TableRow({
                children: getTableRow([
                    opk3,
                    valueConvert(item3['WARTOŚĆ KOSZTU [ZŁ]']),
                    valueConvert(item3['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%',
                ], {...bodyStyle, backgroundColor:'white' })
              }))
                return 0
            })
          }
            return 0
        })
      }
      return 0
    })

    let table = new Table({
      rows: rows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      table
    ]

    let doc = new Document({ 
        sections: [{
            properties: { page: { 
                size: { 
                    // height: convertMillimetersToTwip(210),
                    // width: convertMillimetersToTwip(297) 
                },
                margin: {
                    top: convertMillimetersToTwip(15),
                    right: convertMillimetersToTwip(15),
                    bottom: convertMillimetersToTwip(15),
                    left: convertMillimetersToTwip(15),
                },
            }},
            children: paragraphs
        }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();

    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }

  if(tableData){
    return (
      <>
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} />
        <table className='table table-border tableRaporty'  refresh={nestedLoading} id='tabela6'>
          <thead className='headerColor'>
            <tr className=''>
              {header.map((title,i) => { return(
              <th key={i} 
              className="headerColor" >
               {title}
              </th>) })}
            </tr>
          </thead>
          <tbody className=''>
            {Object.entries(tableData).map(([opk, item], i) => {
              return (
                <>
                <tr key={i}  className={opk==='Wartość ogółem'? "tryColor tdTitles":"tryColor"}>
                  {opk!== "Wartość ogółem"?
                    <td style={{cursor: 'pointer'}} onClick={()=>{showOPKtoggle(opk)}}>
                        {showOPK[opk]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>
                        :<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                      {opk}
                    </td> : <td > {opk} </td>
                  }
                  <td className='rightAlignCell'>{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                  <td className='rightAlignCell' style={{width:"12%"}}>{valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                </tr>
                {/* first nested rows */}
                {item['children']!==undefined && showOPK[opk] && 
                  <>{Object.getOwnPropertyNames(item['children']).length===0?
                    <tr><td colSpan='3'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                    Object.entries(item['children']).map(([opk2, item2], i2) => {
                      return (<>
                       <tr key={opk2} className='' refresh={refreshNested}>
                          {i===0?
                          <td style={{cursor: 'pointer'}} onClick={()=>{showOPKnestedtoggle(opk2, opk)}}>
                            {showOPKnested[opk2]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>
                            :<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                            <span>{opk2}</span>
                          </td>
                          :
                          <td className=''>
                            <span style={{marginLeft: '20px'}}>{opk2}</span>
                          </td>}
                          <td className='rightAlignCell'>{valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                          <td className='rightAlignCell'>{valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                        </tr>
                        {/* second nested rows */}
                        {item2['children']!==undefined && showOPKnested[opk2] && <>
                          {Object.getOwnPropertyNames(item2['children']).length===0?
                            <tr><td colSpan='3'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                            Object.entries(item2['children']).map(([opk3, item3], i3) => {
                              return (<>
                              <tr key={opk2} className='' refresh={refreshNested}>
                                  <td className=''> <span style={{marginLeft: '20px'}}>{opk3}</span> </td>
                                  <td className='rightAlignCell'>{valueConvert(item3['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                                  <td className='rightAlignCell'>{valueConvert(item3['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                                </tr>
                              </>)
                            })
                        }</> }
                      </>)
                    })
                 }</> }
                </>
                )
            })}
          </tbody>
        </table>
        </>
    )
  }else{
    return <Spinner />
  }
}

Report6.propTypes = {
  tableData: PropTypes.object,
  refresh: PropTypes.bool,
  showOPKtoggle: PropTypes.func,

}

const mapStateToProps = state => ({
  nestedLoading: state.reportReducer.nestedLoading,
})

export default connect(mapStateToProps, {getCode6Nested})(Report6)